var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotesD(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 117.00000000000001,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_2",
    fill: "#00AEEF",
    d: "m79.79139,86.54575l0,4.64042c0,1.28192 -1.04605,2.32021 -2.33755,2.32021l-51.42077,0c-1.2915,0 -2.33755,-1.03829 -2.33755,-2.32021l0,-4.64042c0,-1.28192 1.04605,-2.32021 2.33755,-2.32021l51.42077,0c1.2915,0 2.33755,1.03829 2.33755,2.32021zm18.69827,-71.91813l0,88.15855c0,5.12454 -4.18631,9.27979 -9.34913,9.27979l-74.79308,0c-5.16283,0 -9.34913,-4.15526 -9.34913,-9.27979l0,-88.15855c0,-5.12454 4.18631,-9.27979 9.34913,-9.27979l2.33755,0c1.2915,0 2.33755,1.03829 2.33755,2.32021l0,4.64042c0,1.28192 1.04605,2.32021 2.33755,2.32021l4.67509,0c1.2915,0 2.33755,-1.03829 2.33755,-2.32021l0,-4.64042c0,-1.28192 1.04605,-2.32021 2.33755,-2.32021l4.67509,0c1.2915,0 2.33755,1.03829 2.33755,2.32021l0,4.64042c0,1.28192 1.04605,2.32021 2.33755,2.32021l4.67509,0c1.2915,0 2.33755,-1.03829 2.33755,-2.32021l0,-4.64042c0,-1.28192 1.04605,-2.32021 2.33755,-2.32021l4.67509,0c1.2915,0 2.33755,1.03829 2.33755,2.32021l0,4.64042c0,1.28192 1.04605,2.32021 2.33755,2.32021l4.67509,0c1.2915,0 2.33755,-1.03829 2.33755,-2.32021l0,-4.64042c0,-1.28192 1.04605,-2.32021 2.33755,-2.32021l4.67509,0c1.2915,0 2.33755,1.03829 2.33755,2.32021l0,4.64042c0,1.28192 1.04605,2.32021 2.33755,2.32021l4.67509,0c1.2915,0 2.33755,-1.03829 2.33755,-2.32021l0,-4.64042c0,-1.28192 1.04605,-2.32021 2.33755,-2.32021l2.32912,0c5.16283,0 9.34913,4.15421 9.34913,9.27979zm-9.34492,88.1575l-0.00421,-69.59792l-74.79308,0l0,69.59896l74.79729,0l0,-0.00105z"
  }), /*#__PURE__*/React.createElement("text", {
    stroke: "null",
    transform: "matrix(1.05342 0 0 1.04561 -0.776149 3.07397)",
    fill: "#00AEEF",
    x: 36.88564,
    y: 67.73678,
    id: "svg_3",
    strokeWidth: 0,
    fontSize: 40,
    fontFamily: "'Poppins'",
    textAnchor: "start",
    xmlSpace: "preserve",
    fontWeight: "bold",
    fontStyle: "normal"
  }, "D")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesD);
export default __webpack_public_path__ + "static/media/notes_D.ab16ae309b1fde74cb483e285d760a48.svg";
export { ForwardRef as ReactComponent };